// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___oDDWA","root__name":"style-module__root__name___fEnmG","root__wrapper":"style-module__root__wrapper___EIb0F","root__wrapper_item":"style-module__root__wrapper_item___zinUM"};
    if(module.hot) {
      // 1697460472189
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  